<template>
  <div class="container" v-loading="loading">
    <div class="inside-banner">
      <el-carousel
          class="banner-carousel"
          indicator-position="none"
          loop
          autoplay
          arrow="never"
      >
        <el-carousel-item v-for="(item, index) in topImgList" :key="index">
          <img
              :src="item.src"
              :alt="item.title"
              class="carousel-img"
          />
        </el-carousel-item>
      </el-carousel>

      <img
          :src="require('@/assets/img/media/title.jpg')"
          alt="媒体板块标题"
          class="banner-title-img"
      />

      <!-- 四模块新闻列表区域：替换为el-row+el-col布局 -->
      <div class="news-section">
        <!-- 第一行：企业动态 + 产品动态 -->
        <el-row :gutter="40" class="news-row">
          <el-col :span="12" :xs="24" :sm="24" :md="12">
            <div class="news-card" v-if="enterpriseNews.length > 0">
              <div class="news-list">
                <div class="news-item" v-for="news in enterpriseNews" :key="news.id" @click="toNewsInfo(news)">
                  <img
                      v-if="news.thumbnail"
                      :src="news.thumbnail"
                      :alt="news.title"
                      class="news-img"
                  />
                  <div v-else class="news-img placeholder"></div>
                  <div class="news-content">
                    <p class="news-title">{{news.title}}</p>
                    <p class="news-date">{{formatDate(news.date)}}</p>
                  </div>
                </div>
              </div>
              <el-button class="more-btn" type="text" @click="toMoreNews(NodeIdEnum.ARTICLE_TYPE_QYDT_ID.value)">更多企业动态</el-button>
            </div>
          </el-col>
          <el-col :span="12" :xs="24" :sm="24" :md="12">
            <div class="news-card" v-if="productNews.length > 0">
              <div class="news-list">
                <div class="news-item" v-for="news in productNews" :key="news.id" @click="toNewsInfo(news)">
                  <img
                      v-if="news.thumbnail"
                      :src="news.thumbnail"
                      :alt="news.title"
                      class="news-img"
                  />
                  <div v-else class="news-img placeholder"></div>
                  <div class="news-content">
                    <p class="news-title">{{news.title}}</p>
                    <p class="news-date">{{formatDate(news.date)}}</p>
                  </div>
                </div>
              </div>
              <el-button class="more-btn" type="text" @click="toMoreNews(NodeIdEnum.ARTICLE_TYPE_XWDT_ID.value)">更多产品动态</el-button>
            </div>
          </el-col>
        </el-row>

        <!-- 第二行：球员动态 + 球房动态 -->
        <el-row :gutter="40" class="news-row">
          <el-col :span="12" :xs="24" :sm="24" :md="12">
            <div class="news-card" v-if="playerNews.length > 0">
              <div class="news-list">
                <div class="news-item" v-for="news in playerNews" :key="news.id" @click="toNewsInfo(news)">
                  <img
                      v-if="news.thumbnail"
                      :src="news.thumbnail"
                      :alt="news.title"
                      class="news-img"
                  />
                  <div v-else class="news-img placeholder"></div>
                  <div class="news-content">
                    <p class="news-title">{{news.title}}</p>
                    <p class="news-date">{{formatDate(news.date)}}</p>
                  </div>
                </div>
              </div>
              <el-button class="more-btn" type="text" @click="toMoreNews(NodeIdEnum.ARTICLE_TYPE_PLAYER_ID.value)">更多球员动态</el-button>
            </div>
          </el-col>
          <el-col :span="12" :xs="24" :sm="24" :md="12">
            <div class="news-card" v-if="matchNews.length > 0">
              <div class="news-list">
                <div class="news-item" v-for="news in matchNews" :key="news.id" @click="toNewsInfo(news)">
                  <img
                      v-if="news.thumbnail"
                      :src="news.thumbnail"
                      :alt="news.title"
                      class="news-img"
                  />
                  <div v-else class="news-img placeholder"></div>
                  <div class="news-content">
                    <p class="news-title">{{news.title}}</p>
                    <p class="news-date">{{formatDate(news.date)}}</p>
                  </div>
                </div>
              </div>
              <el-button class="more-btn" type="text" @click="toMoreNews(NodeIdEnum.ARTICLE_TYPE_QFDT_ID.value)">更多球房动态</el-button>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="banner-down-wrap">
        <img
            :src="require('@/assets/img/media/down.jpg')"
            alt="媒体板块底部装饰图"
            class="banner-down-img"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {getImgList, selectArticleGroup} from "@/api/home";
import {ImageTypeEnum} from "@/enums/imageTypeEnum";
import {NodeIdEnum} from "@/enums/nodeIdEnum";

export default {
  computed: {
    NodeIdEnum() {
      return NodeIdEnum
    }
  },
  data() {
    return {
      loading: false,
      topImgList: [],
      enterpriseNews: [],
      productNews: [],
      matchNews: [],
      playerNews: []
    }
  },
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      try {
        this.loading = true;
        const [bannerRes, articleRes] = await Promise.all([
          getImgList(ImageTypeEnum.MEDIA_BANNER.value),
          selectArticleGroup()
        ]);
        this.handleBannerData(bannerRes);
        this.handleArticleData(articleRes);
      } catch (error) {
        console.error("页面初始化数据失败：", error);
        this.$message?.error("数据加载失败，请稍后重试");
      } finally {
        this.loading = false;
      }
    },

    handleBannerData(res) {
      const dataList = res.data || [];
      this.topImgList = dataList.filter(item => item.classify === ImageTypeEnum.MEDIA_BANNER.value && item.src);
    },

    handleArticleData(res) {
      if (res.code === 200 && res.data) {
        const mapNews = (list) => (list || []).map(item => ({
          title: item.title,
          date: item.time,
          thumbnail: item.thumbnail,
          id: item.id,
          category: item.category
        }));
        this.enterpriseNews = mapNews(res.data[NodeIdEnum.ARTICLE_TYPE_QYDT_ID.value]);
        this.productNews = mapNews(res.data[NodeIdEnum.ARTICLE_TYPE_XWDT_ID.value]);
        this.playerNews = mapNews(res.data[NodeIdEnum.ARTICLE_TYPE_PLAYER_ID.value]);
        this.matchNews = mapNews(res.data[NodeIdEnum.ARTICLE_TYPE_QFDT_ID.value]);
      } else {
        this.$message.error(res.msg || "获取文章列表失败");
      }
    },

    formatDate(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    //更多点击事件
    toMoreNews(type) {
      this.$router.push({
        path: "/articleHome",
        query: { articleType: type }
      });
    },
    //文章详情
    toNewsInfo(news){
      this.$router.push({
        path: "/article",
        query: { articleId:news.id,type: news.category }
      });
    },
  }
}
</script>

<style scoped lang="scss">
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.fl { float: left; }
.fr { float: right; }
.clearfix::after {
  content: '';
  display: block;
  clear: both;
}

.container{
  position: relative;
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
}

.inside-banner {
  position: relative;
  margin-top: 100px;
  width: 100%;
  overflow: hidden;
}

.banner-carousel {
  width: 100%;
  height:40vw;
  :deep(.el-carousel__container) {
    height: 100%;
  }
  :deep(.el-carousel-item) {
    height: 100%;
  }
}

.carousel-img {
  width: 100%;
  height: 100%;
  object-position: center;
}

.banner-title-img {
  width: 100%;
  display: block;
  object-fit: contain;
  object-position: center;
}

.news-section {
  width: 90%;
  margin: 60px auto 0;
}

.news-row {
  margin-bottom: 60px;
}

.news-card {
  width: 100%;
}

.news-list {
  margin-bottom: 20px;
}

.news-item {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
  cursor: pointer;
}

.news-img {
  width: 80px;
  height: 60px;
  flex-shrink: 0;
  object-fit: cover;
  object-position: center;
  border-radius: 2px;
  &.placeholder {
    background: #eee;
    border: 1px solid #ddd;
  }
}

.news-content {
  flex: 1;
  min-width: 0;
}

.news-title {
  font-size: 14px;
  color: #333;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 4px;
}

.news-date {
  font-size: 12px;
  color: #999;
}

.more-btn {
  display: block;
  width: 200px;
  margin: 0 auto;
  border: 1px solid #0066cc;
  color: #0066cc;
  border-radius: 0;
  padding: 8px 0;
  font-size: 14px;
  &:hover {
    background: #f0f8ff;
    border-color: #0066cc;
    color: #0066cc;
  }
}

.banner-down-wrap {
  width: 100%;
  margin-top: 60px;
  overflow: hidden;
}

.banner-down-img {
  width: 100%;
  display: block;
  object-fit: contain;
  object-position: center;
}

@media (max-width: 768px) {
  .inside-banner {
    margin-top: 80px;
  }
  .news-section {
    width: 100%;
    margin-top: 40px;
  }
  .news-row {
    margin-bottom: 40px;
  }
  .banner-down-wrap {
    margin-top: 40px;
  }
}

@media (max-width: 480px) {
  .inside-banner {
    margin-top: 60px;
  }
  .carousel-img {
    object-fit: contain;
  }
  .news-section {
    margin-top: 30px;
  }
  .news-item {
    gap: 10px;
    margin-bottom: 15px;
    padding: 0 20px;
  }
  .news-img {
    width: 60px;
    height: 45px;
  }
  .news-title {
    font-size: 12px;
  }
  .news-date {
    font-size: 10px;
  }
  .more-btn {
    width: 160px;
    font-size: 12px;
  }
  .banner-down-wrap {
    margin-top: 30px;
  }
}
</style>